import React, { useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import StripeCheckout from "react-stripe-checkout";
import { loadStripe } from "@stripe/stripe-js";
import { BACKEND_ENDPOINT, NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY } from "../const/appConst";

const stripePromise = loadStripe(NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY, {
  stripeAccount: "acct_1On43nKAhEtER47i"
});
const Server = () => {

  const [selectedCountryFree, setSelectedCountryFree] = useState("GB");
  const [selectedCountryLevelI, setSelectedCountryLevelI] = useState("US");
  const [selectedCountryLevelII, setSelectedCountryLevelII] = useState("CA");
  const [selectedCountryNovelist, setSelectedCountryNovelist] = useState("FR");
  const [isChecked, setIsChecked] = useState(false);

  const handleSelect = setter => countryCode => {
    setter(countryCode);
  };
  const handleToggle = () => setIsChecked(prevState => !prevState);
  const switchClassName = isChecked ? "switch checked" : "switch";
  const otherElementClassName = isChecked ? "other-element active" : "other-element";
  const plans = [
    {
      name: "Free",
      monthlyPrice: 0,
      yearlyPrice: 0,
      normallyPrice: 9.99,
      isBestSeller: false,
      features: ["Lowest Price", "character limit", "5 saved novels", "No Premium features"]
    },
    {
      name: "Level I",
      monthlyPrice: 9.99,
      yearlyPrice: 69.99,
      normallyPrice: 9.99,
      isBestSeller: false,
      features: ["10 novel saves", "Higher character limit", "50 daily novels", "Premium features"]
    },
    {
      name: "Level II",
      monthlyPrice: 19.99,
      yearlyPrice: 199.99,
      normallyPrice: 9.99,
      isBestSeller: true,
      features: ["15 novel saves", "Higher character limit", "60 daily novels", "More human like writing", "Faster response time", "Premium features", "Beta access to new features"]
    },
    {
      name: "Novelist",
      monthlyPrice: 29.99,
      yearlyPrice: 269.99,
      normallyPrice: 9.99,
      isBestSeller: false,
      features: ["50 novel saves", "No character limit", "300 daily novels", "More human like writing", "Faster response time", "Premium features", "Beta access to new features", "24/7 Support", "Feature development"]
    }
  ];
  const handlePayment = (plan, isYearly) => {
      
    if (plan.name == "Free") {
        console.log("Free plan doesn't need a subscription");
        return;
    }
        
    const userId = localStorage.getItem("userId");
    const amount = isYearly ? plan.yearlyPrice : plan.monthlyPrice;
    console.log(`Payment initiated for ${amount}, Plan: ${plan.name}`);

    stripePromise.then(stripe => {
      fetch(`${BACKEND_ENDPOINT}/stripe/create-checkout-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: Math.round(amount * 100), // Convert dollars to cents
          plan: plan.name,
          subscriptionPeriod: isYearly? "yearly" : "monthly",
          userId,
        }),
      })
          .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
          })
          .then(data => {
            console.log("Received session ID from server:", data.sessionId);
            return stripe.redirectToCheckout({ sessionId: data.sessionId });
          })
          .then(result => {
            if (result.error) {
              throw result.error;
            }
          })
          .catch(error => {
            console.error("Error during the checkout process:", error);
            alert(`Error during payment processing: ${error.message || error}`);
          });
    }).catch(error => {
      console.error("Error loading Stripe:", error);
      alert(`Error loading payment system: ${error.message || error}`);
    });
  };

  return (
      <>
        <div className="de-gradient-edge-top"></div>
        <div className="de-gradient-edge-bottom"></div>
        <div className="container z-9">
            <div className="row">
                       <div className="col-lg-6 offset-lg-3 text-center">
                         <div className="switch-set">
                           <div>Monthly Plan</div>
                           <div>
                             <input
                                id="sw-1"
                                className={switchClassName}
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleToggle}
                            />
                          </div>
                          <div>Yearly Plan</div>
                          <div className="spacer-20"></div>
                        </div>
                      </div>
            </div>
          <div className="row">
            {plans.map((plan, index) => (
                <div key={plan+index} className="col-xl-3 col-md-6 mb-sm-30 fadeInRight">
                    <div className={`de_pricing-table type-2 ${otherElementClassName}`}>
                        {plan.isBestSeller ? <div className="d-recommend">Best Seller</div>: <span></span>}
                        <div className="d-head">
                            <h3>{plan.name}</h3>
                        </div>
                        <div className="d-price">
                            <h4 className="opt-1">
                                ${plan.monthlyPrice}<span>/mo</span>
                            </h4>
                            <h4 className="opt-2">
                                ${plan.yearlyPrice}<span>/y</span>
                            </h4>
                            <p>
                                Normally <s>${plan.normallyPrice}</s>
                            </p>
                        </div>
                        <div className="d-location">
                            <h4>Server Location</h4>
                            <ReactFlagsSelect
                                className="flags"
                                countries={[
                                    "GB",
                                    "FR",
                                    "DE",
                                    "NL",
                                    "SE",
                                    "FI",
                                    "US",
                                    "QC",
                                    "AU",
                                    "BR",
                                    "TH",
                                    "ID",
                                ]}
                                customLabels={{
                                    GB: "London, England",
                                    FR: "Paris, France",
                                    DE: "Frankurt, Germany",
                                    NL: "Amsterdam, Netherlands",
                                    SE: "Stockholm, Sweden",
                                    FI: "Helsinki, Finland",
                                    US: "Los Angeles, USA",
                                    QC: "Quebec, Canada",
                                    AU: "Sydney, Australia",
                                    BR: "Sau Paulo, Brazil",
                                    TH: "Bangkok, Thailand",
                                    ID: "Jakarta, Indonesia",
                                }}
                                selected={selectedCountryFree}
                                onSelect={handleSelect}
                                searchable={false}
                            />
                        </div>
                        <div className="spacer-5"></div>
                        <div className="d-group">
                            <h4>Top Features</h4>
                            <ul className="d-list">
                                {plan.features.map((feature, index) => (
                                    <li key={feature+index}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="d-action">
                            <button onClick={() => handlePayment(plan, isChecked)} className="btn-main opt-1 w-100">
                                Get Monthly Plan
                            </button>
                            <button onClick={() => handlePayment(plan, isChecked)} className="btn-main opt-2 w-100">
                                Get Yearly Plan
                            </button>
                            <p>Auto re-news at regular rate</p>
                        </div>
                    </div>
                </div>
            ))}
          </div>
        </div>
      </>
  );
  
};

export default Server;
